<template>
  <div id="app">
    <v-app>
      <main>
        <v-container>
          <v-layout align-space-around justify-center column fill-height>
            {{$t('product_status_changes.change_status_to')}}
            <v-flex xs12 sm6>
              <v-select
                v-model="status"
                :items="statuses"
                :label="$t('product_status_changes.selected_status')"
                centre
                required
                v-on:input="selectedStatusChange"
                solo
              ></v-select>
            </v-flex>{{$t('product_status_changes.barcode')}}
            <v-flex xs12 sm6>
              <v-text-field
                :label="$t('product_status_changes.enter_barcode')"
                v-model="barcode"
                ref="barcode"
                id="barcode"
                v-on:keyup.enter="changeStatus"
                solo
                full-width
                autofocus
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout align-space-around justify-center column fill-height>
            {{$t('product_status_changes.action_history')}}
            <div class="vuebar-element" v-bar>
              <!-- el1 -->
              <div>
                <!-- el2 -->
                <!-- your scrollable content -->
                <span v-html="log"></span>
              </div>
              <!-- dragger will be automatically added here -->
            </div>
          </v-layout>
        </v-container>
      </main>
    </v-app>
  </div>
</template>

<script>

import User from "@/models/User.js";
export default {
  name: "product-statuses",
  data() {
    return {
      status: "",
      barcode: "",
      log: "",
      user: new User(this.$session.get('user')),
      statuses: this.$session.get("statusNames").filter(e => {
        return e.table_name === "products"
      }),
      statusRights: this.$session.get("statusRights")
    };
  },
  created() {
    this.filterAllowedStatuses(this.statuses, this.statusRights);

  },
  methods: {
    /**
     * filters status rights to the ones to show
     */
    filterAllowedStatuses(statuses, statusRights) {
      if (this.user["type"] in [0, 1]) {
        return 0; // if admin leave as is
      }
      //filter to leave only owned status rights
      let userRights = statusRights.filter(
        statusRight =>
          statusRight["table_name"] == "products" &&
          statusRight["user_type"] == this.user["type"]
      );
      //go through each status text and check is there a
      //status right with such value
      let allowedTexts = [];
      statuses.forEach(statusText => {
        userRights.forEach(statusRight => {
          if(statusText['status'] == statusRight['after']){
            //check if no duplicates
            if(!allowedTexts.includes(statusText)){
              allowedTexts.push(statusText);
            }
          }
        });
      });
      this.statuses = allowedTexts;
    },

    /**
     * changes status by entered barcode and logs response
     */
    changeStatus() {
      let data = {};
      let headers = {
        Authorization: "Bearer" + " " + this.$session.get("jwt")
      };
      if (this.status) {
        const found = this.statuses.find(e => {
          return e.text === this.status;
        })
        data["status"] = found.status;
        this.$http
          .patch(
            process.env.VUE_APP_ROOT_API + "/products/" + this.barcode,
            data,
            {
              headers
            }
          )
          .then((response) => {
            if (response.status == 200) {
              this.log = `<p> ${this.$t('product_status_changes.success_log_line0')} ${this.barcode} - 
                ${this.$t('product_status_changes.success_log_line1')} " ${this.status} " \n ${this.log} </p>`;
              this.barcode = "";
            } else {
              alert(this.$t('product_status_changes.error'));
            }
          })
          .catch((error)=> {
            if (error.status == 404) {
              this.log = `<p style='color:red'> ${this.$t('product_status_changes.not_found_log_line0')} 
                ${this.barcode} ${this.$t('product_status_changes.not_found_log_line1')} \n ${this.log} </p>`;
            } else if (error.status == 401) {
              this.log = `<p style='color:red'> ${this.$t('product_status_changes.not_allowed_log')} ${this.status} \n ${this.log} </p>`;
            }
            this.barcode = "";
          });
      } else {
        alert(this.$t('product_status_changes.choose_status'));
      }
    },

    selectedStatusChange() {
      document.getElementById("barcode").focus();
    }
  },
  components: {}
};
</script>

<style scoped>
.vuebar-element {
  height: 500px;
  width: 100%;
  background: #ececec;
  border-radius: 2px;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.vb > .vb-dragger {
  z-index: 5;
  width: 12px;
  right: 0;
}

.vb > .vb-dragger > .vb-dragger-styler {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: rotate3d(0, 0, 0, 0);
  transform: rotate3d(0, 0, 0, 0);
  -webkit-transition: background-color 100ms ease-out, margin 100ms ease-out,
    height 100ms ease-out;
  transition: background-color 100ms ease-out, margin 100ms ease-out,
    height 100ms ease-out;
  background-color: rgba(48, 121, 244, 0.1);
  margin: 5px 5px 5px 0;
  border-radius: 20px;
  height: calc(100% - 10px);
  display: block;
}

.vb.vb-scrolling-phantom > .vb-dragger > .vb-dragger-styler {
  background-color: rgba(48, 121, 244, 0.3);
}

.vb > .vb-dragger:hover > .vb-dragger-styler {
  background-color: rgba(48, 121, 244, 0.5);
  margin: 0px;
  height: 100%;
}

.vb.vb-dragging > .vb-dragger > .vb-dragger-styler {
  background-color: rgba(48, 121, 244, 0.5);
  margin: 0px;
  height: 100%;
}

.vb.vb-dragging-phantom > .vb-dragger > .vb-dragger-styler {
  background-color: rgba(48, 121, 244, 0.5);
}
</style>
